import {
  deleteAdminV1OrgSizeSetsId,
  getAdminV1OrgSizeSets,
  getAdminV1OrgSizeSetsId,
  patchAdminV1OrgSizeSetsId,
  postAdminV1OrgSizeSets,
  type CreateSizeSetRequest,
  type SizeSet,
  type UpdateSizeSetRequest,
} from '@nucleus-commerce/api-client/admin';

/** Size sets are a bounded dictionary: the backend returns the whole `{ items }` list, no cursor. */
export const sizeSetsApi = {
  list: (): Promise<SizeSet[]> => getAdminV1OrgSizeSets().then((r) => r.items),
  get: (id: string): Promise<SizeSet> => getAdminV1OrgSizeSetsId({ id }),
  create: (body: CreateSizeSetRequest): Promise<SizeSet> => postAdminV1OrgSizeSets(body),
  update: (id: string, body: UpdateSizeSetRequest): Promise<SizeSet> =>
    patchAdminV1OrgSizeSetsId({ id }, body),
  remove: (id: string): Promise<void> => deleteAdminV1OrgSizeSetsId({ id }),
};
